export default "__VITE_ASSET__f188b6af__"